/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/*jslint white: true */
/*jslint node: true */
/*global jQuery, jQuery, Swiper, ScrollMagic*/

jQuery(document).ready(function () {
	jQuery(".hamburguer, .open-menu").on("click", function () {
		jQuery(".full-menu").toggleClass("active");
		jQuery(".hamburguer").toggleClass("close-hamburguer");

		if ( jQuery(".hamburguer span").text() == "MENU" ) {
			var timeout;

			clearTimeout(timeout);

			jQuery(".hamburguer span").text("FERMER");

			jQuery(".hamburguer .grappe").toggleClass("grappe grappe-active");
			jQuery(".hamburguer .grappe-rotate").toggleClass("grappe-rotate grappe-rotate-active");


			timeout = setTimeout(function() {
				jQuery(".hamburguer .grappe-active").toggleClass("grappe grappe-active");
				jQuery(".hamburguer .grappe-rotate-active").toggleClass("grappe-rotate grappe-rotate-active");
			}, 900);
		} else {
			jQuery(".hamburguer span").text("MENU");

			jQuery(".hamburguer .grappe-active").toggleClass("grappe grappe-active");
			jQuery(".hamburguer .grappe-rotate-active").toggleClass("grappe-rotate grappe-rotate-active");
		}
	});

	jQuery(".full-menu a").on("click", function () {
		jQuery(".full-menu").toggleClass("active");
		jQuery(".hamburguer").toggleClass("close-hamburguer");

		if ( jQuery(".hamburguer span").text() == "MENU" ) {
			var timeout;

			clearTimeout(timeout);

			jQuery(".hamburguer span").text("FERMER");

			jQuery(".hamburguer .grappe").toggleClass("grappe grappe-active");
			jQuery(".hamburguer .grappe-rotate").toggleClass("grappe-rotate grappe-rotate-active");


			timeout = setTimeout(function() {
				jQuery(".hamburguer .grappe-active").toggleClass("grappe grappe-active");
				jQuery(".hamburguer .grappe-rotate-active").toggleClass("grappe-rotate grappe-rotate-active");
			}, 900);
		} else {
			jQuery(".hamburguer span").text("MENU");

			jQuery(".hamburguer .grappe-active").toggleClass("grappe grappe-active");
			jQuery(".hamburguer .grappe-rotate-active").toggleClass("grappe-rotate grappe-rotate-active");
		}
	});
});
